import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { Dossier } from "../../types/Dossier";

export const getMyDossiers = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["dossiers"],
    queryFn: (): Promise<Dossier[]> => {
      return fetchWithAuth<Dossier[]>("getMyDossiers");
    },
    enabled: isQueryEnabled(options),
  });
};
